import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'shared-pickup-label',
    templateUrl: './pickup-label.shared.component.html',
    styleUrls: ['./pickup-label.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PickupLabelComponent implements OnInit {
    @Input() public title: string = 'PICKING UP:';
    @Input() public mode: OLO.Components.PICKUP_MODE = 'filter';
    @Input() public disabled: boolean = false;

    @Output() public onClick: EventEmitter<Event> = new EventEmitter();
    constructor() { }

    ngOnInit(): void { }

    public labelClicked($event: Event): void {
        if (this.disabled) return;

        this.onClick.emit($event);
    }
}
